



























































































































import Vue from "vue";
import Component from "vue-class-component";
import {IRockCrushingRenewalVueModel} from "@/ts/models/IRockCrushingRenewalVueModel";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import {IFeeVueModel} from "@/ts/models/IFeeVueModel";
  import api, { IResult } from "@/ts/functions";
  import Datepicker from 'vuejs-datepicker';

@Component({
  props: {
    formType: {
      type: String
    },
    formName: {
      type: String
    },
  },
    components: {
        Datepicker
  }
})

export default class TRCRenewal extends Vue {
  name: string = "Renewal";
  title: string = "";
  index: number = NaN;
  errorMsgs = ErrorMessages;
  facilities: any = null;
  isReadOnly: boolean = false;
  isLoading: boolean = false;
  facility: any = null;
    form: any = { canHaveFees: false, fees: [] }
    address: string = "";
    facilityName: string = "";
  
  mounted(): void {
    this.initializeComponent(this.name);
  }

  private initializeComponent(routeName: string): void {

    this.$emit("update:title", this.title);
      this.$emit("update:currentIndex", this.index);
      api.getForm(this.$props.formType, 'RockCrushingApplication', this.$route.params.applicationNumber)
          .then(result => {
              this.address = `${result.facilityAddress.streetNumber} ${result.facilityAddress.streetDirection} ${result.facilityAddress.streetName} ${result.facilityAddress.streetType} ${result.facilityAddress.city} ${result.facilityAddress.state}, ${result.facilityAddress.zip}`;
              this.facilityName = result.facilityBuildingName;
          })
          .finally(() => this.isLoading = false);
    this.form = {fees: [{amount: 0, name: 'TRC Renewal Fee'} as IFeeVueModel], canHaveFees: true, oneMonth: false, twoMonths: false, threeMonths: false, originalApplicationNumber: (this.$route.params.applicationNumber == undefined ? "" : this.$route.params.applicationNumber)} as IRockCrushingRenewalVueModel;
  }

  monthCheckboxUpdate(monthNumber: number): void {
    if (monthNumber == 1) {
      this.form.twoMonths = false;
      this.form.threeMonths = false;
      this.form.fees[0].amount = this.form.oneMonth ? 500 : 0;
    }
    else if (monthNumber == 2) {
      this.form.oneMonth = false;
      this.form.threeMonths = false;
      this.form.fees[0].amount = this.form.twoMonths ? 1000 : 0;
    }
    else if (monthNumber == 3) {
      this.form.oneMonth = false;
      this.form.twoMonths = false;
      this.form.fees[0].amount = this.form.threeMonths ? 1500 : 0;
    }
  }
  get total(): number {
    let fees = this.form.fees as IFeeVueModel[];

    if (fees.length === 0) return 0;
    let total: number = 0;

    fees.forEach((obj, ix, arr) => total += obj.amount);

    return total;
  }

  private onError(error: Error): void {
    this.$swal({
      title: "An Error Has Occurred",
      text: error.message,
      showConfirmButton: true,
      type: "error"
    });
  }

  private saveForm(isSubmit: boolean): void {
    this.isLoading = true;
    let form = this.getFormData(isSubmit);

    api.saveForm(this.$props.formType, this.$props.formName, form)
        .then(result => this.onSaveCompleted(result, isSubmit))
        .catch((error: Error) => this.onError(error))
        .finally(() => { this.isLoading = false; });
  }

  private getFormData(isSubmit: boolean): FormData {
    let form = new FormData();
    form.append("ApplicationNumber", "");
    form.append("AccountNumber", "");
    form.append("Type", this.$props.formType);
    form.append("Name", this.$props.formName);
    form.append("IsSubmit", isSubmit.toString());

    form.append("Data", JSON.stringify(this.form, this.ignoreIds));
    
    return form;
  }

  private ignoreIds(key: string, value: any): any {
    if (key === "id") {
      return undefined;
    }
    return value;
  }

  private showValidationErrors(errors: string[]): void {
    //let html = errors.map(msg => `<li>${msg}</li>`).reduce((a, b, ix, ar) => `${a}${b}`);
    //html = `<ul>${html}</ul>`;
    var strings = errors.toString().split("-- ");
    strings.shift();
    var html = '<ul>'
    for (var i = 0; i < strings.length; i++) {
      let error = strings[i].split(': ')[1];
      html += '<li  style=\"text-align: left;\">' + error.trim() + '</li>';
    }
    html += '</ul>';
    this.$swal({
      title: "Validation Error",
      html: html,
      type: "error",
      showConfirmButton: true
    });
  }

  private onSaveCompleted(result: IResult, isSubmit: boolean): void {
    if (result.isSuccess) {
      this.redirectSuccess(result.message as string, isSubmit);
    } else {
      this.showValidationErrors(result.message as string[]);
    }
  }

  private redirectSuccess(applicationNumber: string, isSubmit: boolean): void {
    if (isSubmit) {
      this.$router.push({
        name: 'RockCrushingRenewalReview',
        params: { applicationNumber: applicationNumber },
        query: this.$route.query
      });
    } else {
      this.$router.push({
        name: "FormSaved",
        params: { applicationNumber: applicationNumber },
        query: this.$route.query
      });
    }
  }
  
  submit(): void {
    this.saveForm(true);
  }

  cancel(): void {
    this.$swal({
      title: "Are You Sure?",
      text: "You currently have unsaved changes.",
      showCancelButton: true,
      showConfirmButton: true
    }).then(result => {
      if (result.value) {
        this.$router.push({ path: "/" });
      }
    });
  }

  get isMonthsError(): boolean {
    return !(this.form.oneMonth || this.form.twoMonths || this.form.threeMonths);
    }

    get isRenewalDateError(): boolean {
        return this.form.dateOfRenewal === null;
    }

  get hasErrors(): boolean {
      return this.isMonthsError || this.isRenewalDateError
  }
}
